<template>
  <ParagraphLink
    class="flex items-center justify-between gap-0.5 truncate rounded text-5.5pt leading-5 transition-colors hover:text-lexmea-pop-lightest"
    :class="{
      'bg-lexmea-selection-lightest font-bold hover:text-lexmea-pop-lightest':
        active,
      'px-2': !columnCollapsed,
    }"
    :legalText="legalTextSlug"
    :legalTextParagraph="paragraph.slug"
    :title="[paragraph.paragraph, paragraph.title].join(' ')"
  >
    <div class="truncate">
      <span>{{ formattedParagraph }}</span>
      <span v-if="!columnCollapsed" class="ml-2"> {{ paragraph.title }}</span>
    </div>
    <BookmarkIcon
      v-if="bookmark"
      :colorClass="`text-entry-${bookmark?.color}-${bookmark?.color_type}`"
      class="h-5 w-5 shrink-0"
    />
  </ParagraphLink>
</template>

<script lang="ts" setup>
import type {
  IBookmark,
  ILegalTextParagraph,
} from "~/models/ILegalTextParagraph";

const props = defineProps<{
  active: boolean;
  paragraph: ILegalTextParagraph;
  legalTextSlug: string;
  bookmark?: IBookmark;
  columnCollapsed: boolean;
}>();

const { paragraph } = toRefs(props);

const { shortenedParagraph } = useShortenedParagraph(paragraph);

const formattedParagraph = computed(() =>
  props.columnCollapsed ? shortenedParagraph.value : paragraph.value.paragraph
);
</script>
